module.exports = {
  sidebar:{
    language:'中文',
    index:'Home',
    dynamic:'News Center',
    d_intro:'About Uniceramics',
    d_news:'News',
    d_media:'Press Releases',
    d_pic:'Photos',
    d_detail:'Detail',
    empty:'',
    exhibitor:'Register Now',
    visitor:'Visitor',
    isit_course:'Download',
    service:'Exhibition Service',
    contact:'Contact us',
    about:'About us',
    live:'live',
    ennews:'News Center',
    overlive:'Overseas Direct Train',
    overlive_1:'2021 Coming Soon (20-24 July) ',
    overlive_2:'2020 Live Playback'
  },
  footer:{
    about:'About us',
    contact:'Contact us',
    weixin:'Official WeChat',
    video:'Official Video'
  },
  index:{
    t1:'Uniceramics Expo 2023',
    t2:'',
    t3:'Ceramics product and application technology exhibition',
    t4:'Ceramics equipment and materials exhibition',
    t5:'Characteristic Halls',
    t6:'Latest News of the Exhibition',
    t7:'',
    blogroll:'Links',
    zcdw:'with the support of'
  },
  btn:{
    exhibitor:'Register now',
    clickMe:'Register now',
    visitor:'Visitor',
    more:'more',
    haiwailive:'2020 Live playback'
  },
  lange: {
    cn:'中文',
    en:'english',
    jp:'日文',
    kr:'韩文'  
  }
}